<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '~ds/lib/utils'

import type { IllustrationVariants } from '.'

import { illustrationVariants } from '.'

const props = defineProps<{
  src?: string;
  alt?: string;
  size?: IllustrationVariants['size'];
  class?: HTMLAttributes['class'];
}>()
</script>

<template>
  <span
    data-slot="illustration"
    :role="src && alt ? undefined : 'presentation'"
    :class="cn(illustrationVariants({ size }), props.class)"
  >
    <slot>
      <img
        v-if="src"
        :src="src"
        :alt="alt ?? ''"
      >
    </slot>
  </span>
</template>
